import BeautyFilterModal from 'components/beautyFilter/BeautyFilterModal';
import React from 'react';
import ReactDOM from 'react-dom';

const BeautyFilterPortal: React.FC = () => {
  const portalRoot = document.getElementById('hMainContainer');
  if (!portalRoot) {
    BLog.error('hMainContainer element not found');
    return null;
  }

  return ReactDOM.createPortal(
    <BeautyFilterModal />,
    portalRoot
  );
};

export default BeautyFilterPortal;